module.exports = __webpack_public_path__ + "static/images/callout_2.196a3a62016faf2325e40f9d34093e5b.gif";